module.exports = __webpack_public_path__ + "img/kn.05da331d.svg";